export default "__VITE_ASSET__8fbd50a5__$_?nuxt_component=async__"